import axios from 'axios';

import { isLocalhost } from './registerServiceWorker';

const ACCESS_TOKEN = 'access_token';

const isDev = true;

const usingLocalBackend = false;


function getWebSocketURL() {
  if (usingLocalBackend) {
    return 'ws://127.0.0.1:8000/';
  }

  if (isDev) {
    return 'wss://dev.getmotivatedbuddies.com/';
  }

  return 'wss://backend.getmotivatedbuddies.com/';
}

const currentEnv = localStorage.getItem('ENV_FLAG');
const prefix = currentEnv === 'prod' ? 'api-prod' : 'api-stag';
const baseURL = `https://${prefix}.getmotivatedbuddies.com/`;
const baseWebSocketURL = `wss://${prefix}.getmotivatedbuddies.com/`;

function getIntercomKey() {
  if (isDev) {
    return 'odzopu5t';
  }
  return 'e08h9yvh';
}

function getChargebeeSiteKey() {
  if (isDev) {
    return 'getmotivatedbuddies-test';
  }
  return 'getmotivatedbuddies';
}

function getSentryDsn() {
  if (isDev) {
    if (isLocalhost)
      return 'https://dbb483f7b8e4435984df3b3df529963c@o224614.ingest.sentry.io/4504663034953728';
    else return 'https://eabc499fc9aa4815aef64c484da8b14b@sentry.io/1383315';
  }

  return 'https://d7cf7669e9a0405fa4092bf8dd300f7e@sentry.io/1383317';
}

function getNewPlatformUrl() {
  if (isDev) {
    return 'https://staging.getmotivated.ai/';
  }
  if (isLocalhost) {
    return 'http://localhost:3001/';
  }

  return 'https://getmotivated.ai/';
}

function getSupabaseUrl() {
  if (isDev) {
    return 'https://llcoveirstozdncqaymz.supabase.co';
  }
  if (isLocalhost) {
    return 'https://llcoveirstozdncqaymz.supabase.co';
  }

  return 'https://hloijjexgrgvssrbykha.supabase.co';
}

function getSupabaseAnonKey() {
  if (isDev) {
    return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxsY292ZWlyc3RvemRuY3FheW16Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM5NTE4ODAsImV4cCI6MjA0OTUyNzg4MH0.ixuQLnd69ZiKlTlg4fnrrn35lASYbQq_Ge43Isqs4HY';
  }
  if (isLocalhost) {
    return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxsY292ZWlyc3RvemRuY3FheW16Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM5NTE4ODAsImV4cCI6MjA0OTUyNzg4MH0.ixuQLnd69ZiKlTlg4fnrrn35lASYbQq_Ge43Isqs4HY';
  }

  return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhsb2lqamV4Z3JndnNzcmJ5a2hhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM5NTE5MjEsImV4cCI6MjA0OTUyNzkyMX0.r9qj-aIQoWd9bI54BZ7OhYL31SWCpPJASZkt1x8v62k';
}
// noinspection SpellCheckingInspection
export const CLIENT_ID = '1h9L7uVLtna8zmdbIID71rOetM1ojG0RD2zcj0aY';
// noinspection SpellCheckingInspection
export const CLIENT_SECRET =
  'lQbcoz3GaXZ0EhevSwsx6k3NDvDZz9c2etsRR2GtqHgLbRV1VgmrheZdIHuoXQCgihDn73KqOE4FB7e8JamNjGGNF9yBNjXOFx4uZdq2lTT9ClSyX8vNaZvRNE1nEmpN';
export const BASE_URI = baseURL;
export const API_URI = `${baseURL}api/`;
export const WEBSOCKET_URI = `${baseWebSocketURL}ws/`;
export const INTERCOM_API_KEY = getIntercomKey();
export const CHARGEBEE_SITE_KEY = getChargebeeSiteKey();
export const SENTRY_DSN = getSentryDsn();
export const NEXT_PUBLIC_SUPABASE_URL = getSupabaseUrl();
export const NEXT_PUBLIC_SUPABASE_ANON_KEY = getSupabaseAnonKey();
export const NEXT_PUBLIC_SITE_URL = getNewPlatformUrl();

export const getAppToken = () => localStorage.getItem(ACCESS_TOKEN);

export const createRequest = (endpoint, method, data) =>
  axios(`${API_URI}${endpoint}`, {
    method,
    headers: { Authorization: `Bearer ${getAppToken()}` },
    data,
  });
